import { Stack, StackProps, Tooltip, Typography } from '@cmg/design-system';
import { useEffect, useRef, useState } from 'react';

import { BooleanIcon } from '../boolean-icon/BooleanIcon';

export type FlagWithNoteSlotProps = Readonly<{
  stack?: StackProps;
}>;

type FlagWithNoteProps = Readonly<{
  flag: boolean | null;
  note: string | null;
  slotProps?: FlagWithNoteSlotProps;
  notesOnSameLine?: boolean;
}>;

export function FlagWithNote({ flag, note, slotProps, notesOnSameLine }: FlagWithNoteProps) {
  const noteRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (noteRef.current) {
      setIsOverflowing(noteRef.current.scrollWidth > noteRef.current.clientWidth);
    }
  }, [note]);

  if (flag === null) {
    return <Typography>-</Typography>;
  }

  const typographyProps = notesOnSameLine
    ? {}
    : { noWrap: true, overflow: 'hidden', textOverflow: 'ellipsis' };

  return (
    <Stack
      {...slotProps?.stack}
      spacing={notesOnSameLine ? 1 : undefined}
      direction={notesOnSameLine ? 'row' : undefined}
    >
      <BooleanIcon value={flag} />
      {note && (
        <Tooltip title={isOverflowing ? note : ''} placement="top" variant="info">
          <Typography ref={noteRef} {...typographyProps}>
            {note}
          </Typography>
        </Tooltip>
      )}
    </Stack>
  );
}
